import React from 'react';
import { ImageIcon } from 'lucide-react';
interface Shot {
  label: string;
  url: string;
}
const shots: Shot[] = [{
  label: 'Login screen',
  url: 'https://cdn.magicpatterns.com/uploads/sv6vW8yZmgM3tWvbbw4BQw/Login-screen.png'
}, {
  label: 'Settings → My Staff',
  url: 'https://cdn.magicpatterns.com/uploads/w2oYCeowDzNNRF3CC2Wwnd/my-staff.png'
}, {
  label: '+ Add User button',
  url: 'https://cdn.magicpatterns.com/uploads/4iatJGUS8iVmKRV3ecz3Hh/add-user.png'
}, {
  label: 'The left-hand menu',
  url: 'https://cdn.magicpatterns.com/uploads/jEbTFKLHZJE3nt6sgE67RC/CRM-Tabs-Basic.png'
}, {
  label: 'Connect your calendar',
  url: 'https://cdn.magicpatterns.com/uploads/w5VuokhvNe48EXK37zuiu7/connect-calendar-options.png'
}, {
  label: 'Social Planner — connect accounts',
  url: 'https://cdn.magicpatterns.com/uploads/oBvyssejfZG1sApNvg4mGZ/social-planner-logins.png'
}, {
  label: 'AI Agents → Voice AI',
  url: 'https://cdn.magicpatterns.com/uploads/mMaah6WuCacqgbhQ6Vx2LV/voice-ai.png'
}];
export function ScreenshotDump() {
  return <section id="screenshot-dump" aria-labelledby="screenshot-dump-title" className="scroll-mt-28 rounded-2xl border border-white/10 bg-[#111214] p-5 text-white shadow-[0_18px_40px_-24px_rgba(0,0,0,0.9)] sm:scroll-mt-24 sm:p-8" data-id="element-87" data-mp="v4d2wqve89bb">
      <div className="flex items-center gap-2.5" data-id="element-88" data-mp="1517vkt4zjfho">
        <ImageIcon className="h-4 w-4 text-[#10b981]" aria-hidden="true" data-id="element-89" data-mp="7h4wg5m8au7p" />
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#10b981]" data-id="element-90" data-mp="cedhcdyrhccn">
          Screenshot library
        </p>
      </div>
      <h2 id="screenshot-dump-title" className="mt-3 font-mono text-xl font-bold tracking-tight text-white sm:text-2xl" data-id="element-91" data-mp="hcevqll8snhs">
        Uploaded screenshots
      </h2>
      <p className="mt-2 max-w-xl text-sm leading-relaxed text-white/70" data-id="element-92" data-mp="3ktx4qwcr40js">
        Raw uploads parked here for reference — ready to drop into the matching media
        slots above.
      </p>

      <ul className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-93" data-mp="3hs263whsbbbp">
        {shots.map(shot => <li key={shot.url} className="overflow-hidden rounded-xl border border-white/10 bg-black/40 transition-all duration-200 hover:-translate-y-1 hover:border-[#10b981]/40" data-id="element-94" data-mp="3cusgafqhgxnc">
            <div className="flex items-center justify-center bg-black/60 p-3" data-id="element-95" data-mp="3ml4zo4mkakrw">
              <img src={shot.url} alt={shot.label} loading="lazy" className="max-h-72 w-full rounded-lg object-contain" data-id="element-96" data-mp="2ytg2oaysp84m" />
            </div>
            <p className="border-t border-white/10 px-4 py-3 font-mono text-[11px] uppercase tracking-[0.16em] text-white/70" data-id="element-97" data-mp="38t6xkdr9pp58">
              {shot.label}
            </p>
          </li>)}
      </ul>
    </section>;
}